import React from "react";

import styles from "../../../../styles/integrations.module.scss";

import { Loading } from "../../../components/Loading";
import { Drawer } from "../../../components/Drawer";
import { Button } from "../../../components/Button";
import { Context } from "pages/Integrations";
import { Select } from "@components";

export default class AtenaAIStoreDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: false,
      loading: false,
      storeId: null,
    };
  }

  componentDidMount() {
    if (this.props.storeId) {
      this.setState({ storeId: this.props.storeId });
    }
  }

  componentDidUpdate({ storeId }) {
    if (this.props.storeId && this.props.storeId !== storeId) {
      this.setState({ storeId: this.props.storeId });
    }
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { storeId } = this.state;

      this.setState({ loading: true });

      await onSave(storeId);

      this.setState({ loading: false });
    } catch (e) {
      alert({
        text: `Não foi possível alterar a configuração: ${e.message}`,
      });

      this.setState({ loading: false });
    }
  }

  buildSelectOptions(options, selectedValue) {
    const builtOptions = options.map((option) => ({
      label: option.name,
      value: option.id,
      selected: option.id === selectedValue,
    }));

    return [
      {
        label: "Selecione",
        value: "",
        selected: !selectedValue,
      },
      ...builtOptions,
    ];
  }

  render() {
    const {
      loading,
      loadingPage,
      storeId,
    } = this.state;
    const { visible, stores, onClose } = this.props;

    console.log('Store::render', storeId, stores);

    const isValid = storeId;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        alreadyDrawer
        title={"Atena.ai - Loja"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading || !isValid}
          >
            Confirmar
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Select
              design="two"
              label="Loja"
              onChange={(e) => this.setState({ storeId: e.target.value })}
              className="mt-20"
              value={storeId}
              options={this.buildSelectOptions(stores, storeId)}
            />
          </div>
        )}
      </Drawer>
    );
  }
}
